import { FC, lazy } from 'react';
import { useParams } from 'react-router-dom';

const Page = lazy(() => import('./page'));

export const ExternalTradeEdit: FC = () => {
  const { externalTradeId } = useParams<{
    externalTradeId: string;
  }>();

  return <Page externalTradeId={externalTradeId} />;
};
